export const ACTUALIZAR_LIST_ACTIVO = "ACTUALIZAR_LIST_ACTIVO";
export const CALCULAR_MANTENIMIENTOS_ACTIVOS = "CALCULAR_MANTENIMIENTOS_ACTIVOS"
export const AGREGAR_ACTIVO = "AGREGAR_ACTIVO";  
export const MODIFICAR_ACTIVO = "MODIFICAR_ACTIVO";
export const ACTUALIZAR_PROCS_PROGRAMADOS = "ACTUALIZAR_PROCS_PROGRAMADOS";
export const ACTUALIZAR_DOCSXACTIVO = "ACTUALIZAR_DOCSXACTIVO";
export const SET_FILTERS = "SET_FILTERS";
export const SET_INFO_DASHBOARD_ACTIVOS = "SET_INFO_DASHBOARD_ACTIVOS";

export const MODIFICAR_FILTROS = "MODIFICAR_FILTROS"
export const INICIALIZAR_FILTROS = "INICIALIZAR_FILTROS"
export const MODIFICAR_FILTROS_RANGO = "MODIFICAR_FILTROS_RANGO"
export const MODIFICAR_FILTROS_ESTADOS = "MODIFICAR_FILTROS_ESTADOS"
export const SET_PROCEDIMIENTOS = "SET_PROCEDIMIENTOS"
